module.exports = __webpack_public_path__ + "img/winMain.944f19a7.png";